import * as S from './styles.ts';
import { Editable, useSlate } from 'slate-react';
import { useEffect, useState } from 'react';
import { Transforms } from 'slate';
import {
  renderElement,
  renderLeaf,
} from '@admin/config/overrides/fieldTypes/MarkdownEditor/helpers';

const getFirstChildPath: any = (path: any, existingPath?: number[]) => {
  let pathArr = existingPath || [0];
  if (path[0].children) {
    pathArr.push(0);
    return getFirstChildPath(path[0].children, pathArr);
  }
  return pathArr;
};

const EditorContent = ({ disabled }) => {
  const editor = useSlate();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (!mounted) {
      setMounted(true);
      setTimeout(() => {
        const { children } = editor;
        const path = getFirstChildPath(children);
        Transforms.select(editor, {
          offset: 0,
          path,
          anchor: { offset: 0, path },
          focus: { offset: 0, path },
        });
      }, 50);
    }
  }, [mounted]);

  return (
    <S.EditorContentWrapper $disabled={disabled}>
      <S.EditorContent>
        <Editable
          renderElement={renderElement}
          renderLeaf={renderLeaf}
          autoFocus
          disabled={disabled}
        />
      </S.EditorContent>
    </S.EditorContentWrapper>
  );
};

export default EditorContent;
